import { specificationsStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsSpecifications";
import { css } from "styled-components";

specificationsStyles.specificationsAccordion = {
    headingLevel: 2,
    css: css`
        * {
            margin-top: 0px !important;
            margin-bottom: 0px !important;
        }
    `,
};
